interface ImageUploadFieldProps {
  label: string;
  helperText?: string;
  multiple?: boolean;
  disabled?: boolean;
  onChange?: (files: FileList | null) => void;
}

export function ImageUploadField({ label, helperText, multiple, disabled, onChange }: ImageUploadFieldProps) {
  return (
    <label className="block">
      <span className="text-sm text-content-secondary">{label}</span>
      <input
        className="mt-2 block w-full rounded-md border border-cyan-300/20 bg-black/30 px-3 py-3 text-sm text-content-secondary file:mr-4 file:rounded file:border-0 file:bg-cyan-300 file:px-3 file:py-2 file:text-sm file:font-semibold file:text-ink"
        type="file"
        accept="image/*"
        multiple={multiple}
        disabled={disabled}
        onChange={(event) => onChange?.(event.target.files)}
      />
      {helperText && <span className="mt-2 block text-xs text-content-muted">{helperText}</span>}
    </label>
  );
}
